import React from 'react';
import { BsGear, BsArchive } from "react-icons/bs";

const UserListItem = ({ user, onEditHandler = () => { }, onArchiveHandler = () => { }}) => {
    const { id, email, role, userProjects } = user;

    return (
        <div key={id} className='list-row'>
            <div className='center id'>{ id }</div>
            <div className='flex-start email'>{email}</div>
            <div className='flex-start projects'>
                {role === 0 ?
                    <div className='project-element' key={'all'}>Все</div>
                    :
                    userProjects.map((project) => <div className='project-element' key={project.id}>{project.name}</div>
                )}
            </div>
            <div className='center actions'>
                <BsGear className='icon-button' color='green' onClick={() => onEditHandler(id)} />
                {email !== 'admin@feedapi.live' &&
                    <BsArchive className='icon-button' color='red' onClick={() => onArchiveHandler(id)} />
                }
            </div>
        </div>
    );
};

export default UserListItem;
